/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Failed_To_Generate_PersonalityInputs */

const en_failed_to_generate_personality = /** @type {(inputs: Failed_To_Generate_PersonalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to generate personality`)
};

const es_failed_to_generate_personality = /** @type {(inputs: Failed_To_Generate_PersonalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al generar personalidad`)
};

const fr_failed_to_generate_personality = /** @type {(inputs: Failed_To_Generate_PersonalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de la génération de la personnalité`)
};

const de_failed_to_generate_personality = /** @type {(inputs: Failed_To_Generate_PersonalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Generieren der Persönlichkeit`)
};

const ja_failed_to_generate_personality = /** @type {(inputs: Failed_To_Generate_PersonalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ペルソナの生成に失敗しました`)
};

const zh_failed_to_generate_personality = /** @type {(inputs: Failed_To_Generate_PersonalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无法生成 AI 个性设定`)
};

const ar_failed_to_generate_personality = /** @type {(inputs: Failed_To_Generate_PersonalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فشل في إنشاء الشخصية`)
};

const id_failed_to_generate_personality = /** @type {(inputs: Failed_To_Generate_PersonalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gagal membuat kepribadian`)
};

const it_failed_to_generate_personality = /** @type {(inputs: Failed_To_Generate_PersonalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile generare la personalità`)
};

const ru_failed_to_generate_personality = /** @type {(inputs: Failed_To_Generate_PersonalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось сгенерировать индивидуальность`)
};

const pt_failed_to_generate_personality = /** @type {(inputs: Failed_To_Generate_PersonalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha ao gerar personalidade`)
};

const ko_failed_to_generate_personality = /** @type {(inputs: Failed_To_Generate_PersonalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`페르소나 생성 실패`)
};

/**
* | output |
* | --- |
* | "Failed to generate personality" |
*
* @param {Failed_To_Generate_PersonalityInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const failed_to_generate_personality = /** @type {((inputs?: Failed_To_Generate_PersonalityInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Failed_To_Generate_PersonalityInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_failed_to_generate_personality(inputs)
	if (locale === "es") return es_failed_to_generate_personality(inputs)
	if (locale === "fr") return fr_failed_to_generate_personality(inputs)
	if (locale === "de") return de_failed_to_generate_personality(inputs)
	if (locale === "ja") return ja_failed_to_generate_personality(inputs)
	if (locale === "zh") return zh_failed_to_generate_personality(inputs)
	if (locale === "ar") return ar_failed_to_generate_personality(inputs)
	if (locale === "id") return id_failed_to_generate_personality(inputs)
	if (locale === "it") return it_failed_to_generate_personality(inputs)
	if (locale === "ru") return ru_failed_to_generate_personality(inputs)
	if (locale === "pt") return pt_failed_to_generate_personality(inputs)
	return ko_failed_to_generate_personality(inputs)
});